module.exports = "<div class=\"hp-module\">\n\t<div class=\"hp-inner\">\n\t\t<action-items show-filters=\"true\" show-refresh-button=\"true\" show-see-all=\"false\" show-completed-today=\"true\" source=\"all_items\"></action-items>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/actionItems/actionItems.html
// module id = 537
// module chunks = 1